module.exports = __webpack_public_path__ + "static/media/vishnu.19a80f9a.webp";